var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dividend"}},[_c('playertable',{attrs:{"headers":_vm.divheaders,"itemsWithSno":_vm.itemsWithSno}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }